import { useError } from "../../context/useErrorContext"
import { PutRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { useTranslation } from "react-i18next"

export interface UpdateResellerProfileRequest {
  name: string
  phoneNumber: string
  documentCpfCnpj: string
}

export const useUpdateResellerProfile = () => {
  const { t } = useTranslation("general")

  const { setError } = useError()

  const handleUpdateResellerProfile = async (request: UpdateResellerProfileRequest, onSuccess: () => void) => {
    try {
      const response = await PutRequest(API_ROUTES.RESELLER.UPDATE_PROFILE, request, ERequestType.Reseller)

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess()
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    }
  }

  return { handleUpdateResellerProfile }
}
